<template>
  <base-card :loading="isListPending" tabled-mobile>
    <template v-slot:body-top>
      <base-card-title>Transaction history</base-card-title>
    </template>
    <template v-if="transactions.length">
      <div class="d-none d-sm-block">
        <base-table borderless>
          <thead>
            <tr>
              <th v-if="hasMultipleAccounts()">Account</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(transaction, key) in transactions" :key="key">
              <td v-if="hasMultipleAccounts()">{{ transaction.account.alias.toUpperCase() }}</td>
              <td>{{ getDescription(transaction) }}</td>
              <td>{{ $formatting.toCurrency(transaction.amount) }}</td>
              <td>{{ $dates.toDateTime(transaction.createdAt) }}</td>
              <td :class="getStatusClass(transaction.status)">
                {{ transaction.status }}
              </td>
            </tr>
          </tbody>
        </base-table>
      </div>
      <div class="d-sm-none">
        <base-table borderless>
          <tbody>
            <template v-for="(transaction, key) in transactions">
              <tr :key="key">
                <td>
                  <div class="row">
                    <div class="col-7">
                      {{ getDescription(transaction) }}
                    </div>
                    <div class="col-5 text-right">
                      {{ $formatting.toCurrency(transaction.amount) }}
                    </div>
                    <div class="col-7">
                      {{ $dates.toDateTime(transaction.createdAt) }}
                    </div>
                    <div class="col-5 text-right" :class="getStatusClass(transaction.status)">
                      {{ transaction.status }}
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </base-table>
      </div>
    </template>
    <template v-else>
      <p>
        You haven't made any transactions yet.
      </p>
    </template>
    <template v-if="transactions.length && pages > 1" v-slot:body-bottom>
      <base-pagination :current="page" :total="pages" @go="request" />
    </template>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'
import paymentTypes from '@/data/paymentTypes'

export default {
  name: 'UserTransactions',

  data: () => ({
    page: 1
  }),

  created () {
    this.request()
  },

  computed: {
    ...mapState({
      isListPending: store => store.core.transactions.isListPending,
      pages: store => store.core.transactions.totalPages,
      transactions: store => store.core.transactions.rows
    })
  },

  methods: {
    getDescription (transaction) {
      if (this.$_.isPlainObject(transaction.type)) {
        return transaction.type.description
      }

      return this.$_.has(paymentTypes, transaction.type) ? paymentTypes[transaction.type].description : ''
    },

    getStatusClass (status) {
      if (status === 'SUCCESS') {
        return 'text-success'
      }

      if (status === 'FAILED') {
        return 'text-danger'
      }

      return ''
    },

    hasMultipleAccounts () {
      return this.$auth.user.accounts.length > 1
    },

    request (page) {
      if (page) {
        this.page = page
      }

      this.$store.dispatch('core/transactions/list', {
        page: this.page,
        query: {
          'status::string::ne': 'PENDING'
        }
      })
    }
  }
}
</script>
